import { makeStyles } from '@material-ui/core';

import { styles } from '../styles';

export const useStyles = makeStyles(styles);
